<template>
  <div>
    <div v-if="showLogin" class="login_box"><img src="@assets/images/login.gif" alt=""></div>
    <div class="navbar">防伪码识别</div>
    <img class="img" src="@assets/images/roots1.jpg" />
    <div class="import">
      <div class="inp">
        <div class="flexText">
          <img class="flexImg" src="@assets/images/suyuan.png" />
          <input
            class="flexInp"
            v-model="securityCode"
            placeholder="请输入防伪码"
          />
        </div>
        <div class="btn" :class="btn?showLogin?'btn2':'btn1':'btn2'" @click="checkRes">
          <span>开始查询</span>
        </div>
      </div>
    </div>
    <div class="prompt">
      <span>防伪码说明:</span>
      <span>1.刮开您所购买的产品上的防伪标识</span>
      <span>2.在本网页上的产品防伪框输入防伪码查询</span>
      <span>3.或直接在产品包装上扫描二维码进行扫码查询</span>
      <span>4.点击"开始查询"按钮进行产品真伪查询</span>
    </div>
  </div>
</template>

<script>
import { verifycode } from "@api/roots";
import { getQueryValue } from "@utils/utils";
import localStorage from "../../utils/store/localStorage";
export default {
  name: "roots",
  data: function() {
    return {
      securityCode: "",
      btn: false,
      showLogin:false
    };
  },
  mounted: function() {
    // console.log('getUrlParams',this.getUrlParams('shopid'))
    // let newShopId = this.getUrlParams('shopid')
    this.getCode();
  },
  methods: {
    //获取地址栏参数，key:参数名称
  //  getUrlParams(key) {
  //     let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
  //     let r = window.location.search.substr(1)
  //       .match(reg);
  //     if (r != null)
  //       return unescape(r[2]);
  //     return null;
  //   },
    //防伪码查询
    verifycode: function() {
      if (this.showLogin) return
      this.showLogin = true
      var that = this;
      verifycode({
        anti_code: this.securityCode
      })
        .then(res => {
          that.showLogin = false
          if (res.status == "200" && res.msg == "ok") {
            that.$dialog.toast({ mes: "您查询的产品是正品" });
            localStorage.set("info", res.data);
            that.$router.replace({
              path: "/rootsDetail",
              query: { serial_code: that.securityCode }
            });
          }
        })
        .catch(err => {
          that.showLogin = false
          that.$dialog.error(err.msg);
        });
    },
    checkRes: function() {
      if (this.btn) {
        this.verifycode();
      }
    },
    getCode() {
      var code = getQueryValue("serial_code");
      if (code) {
        code = code.replace("#/", "");
        this.securityCode = code;
        this.btn = true;
        this.verifycode();
      }
    }
  },
  watch: {
    securityCode: function(val) {
      if (val.length >= 4) {
        this.btn = true;
      } else {
        this.btn = false;
      }
    }
  }
};
</script>
<style scoped>
.navbar {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #00a64c;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  font-size: 18px;
}
.img {
  width: 100%;
  margin-top: -1px;
}
.import {
  width: 100%;
  height: 180px;
}
.inp {
  width: 80%;
  height: 100%;
  margin: 0 10%;
}
.btn {
  width: 100%;
  height: 45px;
  border-radius: 50px;
  line-height: 45px;
  text-align: center;
  color: #ffffff;
  font-size: 17px;
}
.btn1 {
  background-color: #00a64c;
}
.btn2 {
  background-color: #b6cdc0;
}
.flexText {
  width: 100%;
  height: 130px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.flexImg {
  width: 40px;
  height: 35px;
  vertical-align: middle;
}
.flexInp {
  height: 35px;
  flex-grow: 1;
  padding-left: 10px;
  border-bottom: 1px solid #acdcb4;
}
.prompt {
  width: 80%;
  margin: 20px 10% 0px;
  display: flex;
  flex-direction: column;
  color: #8d8d8d;
}
.flexInp::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: #8d8d8d;
}
.flexInp:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 适配火狐 */
  color: #8d8d8d;
}
.flexInp::-moz-placeholder {
  /* Mozilla Firefox 19+ 适配火狐 */
  color: #8d8d8d;
}
.flexInp:-ms-input-placeholder {
  /* Internet Explorer 10+  适配ie*/
  color: #8d8d8d;
}
.login_box{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -60px;
  margin-left: -60px;
  width: 120px;
  height: 120px;
}
.login_box img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
